import PropTypes from "prop-types";
import React from "react";
import { intlShape } from "react-intl";

const Select = ({
  children,
  className,
  readOnly,
  value,
  defaultValue,
  error,
  flat,
  boxed,
  intl,
  ...props
}) => {
  delete props.meta;

  //Containing a possible error
  if (boxed) {
    console.warn("Boxed attribute is deprecated on Select elements."); //eslint-disable-line no-console
  }

  if (flat) {
    console.warn("Flat attribute is deprecated on Select elements."); //eslint-disable-line no-console
  }

  let actualValue;
  if (value) {
    actualValue = value;
  } else if (defaultValue) {
    actualValue = defaultValue;
  }

  //  const prefixCls = "select";
  //  const inputCls = `${prefixCls}__input`;

  /*  const classNames = classnames(
    prefixCls,
    {
      [`${prefixCls}--readonly`]: readOnly,
      [`${prefixCls}--error`]: error,
    },
    className
  );*/

  if (readOnly) {
    return actualValue;
  }

  return (
    <span className="cxa-c-form__select-box">
      <select value={value} {...props}>
        {children}
      </select>
    </span>
  );
};

Select.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.string,
  underline: PropTypes.bool,
  boxed: PropTypes.bool,
  flat: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  meta: PropTypes.object,
  intl: intlShape,
};

export default Select;



// WEBPACK FOOTER //
// ./casper/sass/components/select/select.js